import { ROUTE_UI_SECTION_NAME } from '../constants/route'
import { PRIMARY_USER_ROLES } from '../constants/user'

import { useInitData } from './useInitData'
import { useUserData } from './useUserData'

export function useIsUserProfileNGAvailable() {
  const { availableSections } = useInitData()
  const userData = useUserData()

  return (
    !!availableSections?.[ROUTE_UI_SECTION_NAME.userProfileDetail] &&
    PRIMARY_USER_ROLES.includes(userData?.role)
  )
}
